/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Odkaz na dodavatele`
};

const da_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Leverandør reference`
};

const de_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Lieferantenreferenz`
};

const en_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Supplier reference`
};

const es_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Referencia del proveedor`
};

const fr_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Référence fournisseur`
};

const hu_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Szállító referencia`
};

const it_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Riferimento fornitore`
};

const nl_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Leveranciersreferentie`
};

const pl_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Nr referencyjny dostawcy`
};

const pt_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Referência do fornecedor`
};

const sv_supplier_reference = /** @type {(inputs: {}) => string} */ () => {
	return `Leverantörsreferens`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const supplier_reference = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.supplier_reference(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("supplier_reference", locale)
	if (locale === "cs") return cs_supplier_reference(inputs)
	if (locale === "da") return da_supplier_reference(inputs)
	if (locale === "de") return de_supplier_reference(inputs)
	if (locale === "en") return en_supplier_reference(inputs)
	if (locale === "es") return es_supplier_reference(inputs)
	if (locale === "fr") return fr_supplier_reference(inputs)
	if (locale === "hu") return hu_supplier_reference(inputs)
	if (locale === "it") return it_supplier_reference(inputs)
	if (locale === "nl") return nl_supplier_reference(inputs)
	if (locale === "pl") return pl_supplier_reference(inputs)
	if (locale === "pt") return pt_supplier_reference(inputs)
	return sv_supplier_reference(inputs)
};